import { h } from "@stencil/core";
/**
 * @slot - The slot where the ch-dropdown-item is placed.
 */
export class ChActionGroupItem {
    constructor() {
        this.floating = false;
    }
    el;
    componentWillLoad() {
        const parentAction = this.el.closest("ch-action-group");
        // Hide items at the start to improve CLS
        if (parentAction) {
            this.floating =
                parentAction.itemsOverflowBehavior === "ResponsiveCollapse";
        }
    }
    render() {
        return h("slot", null);
    }
    static get is() { return "ch-action-group-item"; }
    static get originalStyleUrls() {
        return {
            "$": ["action-group-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["action-group-item.css"]
        };
    }
    static get properties() {
        return {
            "floating": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "`true` if the control is floating. Useful to implement the\n`\"ResponsiveCollapse\"` value for the `itemsOverflowBehavior` property of\nthe ch-action-group control."
                },
                "attribute": "floating",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=action-group-item.js.map
